<template>
  <v-radio-group
    :value="value"
    :rules="rules"
    persistent-hint
    @change="$emit('update:value', $event)"
  >
    <v-radio
      v-for="(option, i) in options"
      :key="i"
      :label="option"
      :value="option"
    ></v-radio>
  </v-radio-group>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data() {
    return {};
  },
  props: {
    value: {
      type: [String],
    },
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
